export default {
  people: {
    title: '¡Conectamos Personas con Tecnologías!',
    description:
      'Sabemos que las personas son nuestro mayor patrimonio. Por eso, cuidamos, acogemos, formamos y desarrollamos a nuestro #timeSIS, por medio de recursos educativos, tecnológicos, comportamentales y programas de salud y bienestar. De esta forma, garantizamos entregas alineadas con las expectativas y que generan valor real para los clientes y para nuestros colaboradores.',
  },
}
